import React, { forwardRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface BodyPortalProps {
  children?: React.ReactNode;
}

const BodyPortal = forwardRef<HTMLDivElement, BodyPortalProps>(function BodyPortal({ children }, ref) {
  const [dom, setDom] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    const portalDom = document.createElement('div');
    setDom(portalDom);
    if (typeof ref === 'function') {
      ref(portalDom);
    } else if (ref) {
      ref.current = portalDom;
    }
    document.body.appendChild(portalDom);
    return () => {
      if (typeof ref === 'function') {
        ref(null);
      } else if (ref) {
        ref.current = null;
      }
      document.body.removeChild(portalDom);
    };
  }, [ref]);

  return dom ? ReactDOM.createPortal(children, dom) : null;
});

export default BodyPortal;
